import { createTheme } from "@mui/material/styles";

// Reading surfaces stay quiet; contrast and spacing identify the next action.
export const appTheme = createTheme({
  palette: {
    primary: { main: "#234e64", dark: "#18394a", light: "#dce8ec" },
    secondary: { main: "#786247" },
    background: { default: "#f6f5f1", paper: "#ffffff" },
    text: { primary: "#25353b", secondary: "#5d6c71" },
    divider: "#dfe4e2",
    success: { main: "#397259" },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: '"Segoe UI", "Noto Sans", "Helvetica Neue", Arial, sans-serif',
    h3: {
      fontSize: "clamp(1.8rem, 4vw, 2.6rem)",
      fontWeight: 650,
      letterSpacing: "-0.035em",
      lineHeight: 1.2,
    },
    h4: {
      fontSize: "clamp(1.5rem, 3vw, 2rem)",
      fontWeight: 600,
      letterSpacing: "-0.025em",
      lineHeight: 1.3,
    },
    h5: { fontWeight: 600, letterSpacing: "-0.02em" },
    h6: { fontWeight: 600, fontSize: "1.1rem" },
    body1: { lineHeight: 1.65 },
    body2: { lineHeight: 1.6 },
    button: { textTransform: "none", fontWeight: 600 },
    overline: { letterSpacing: "0.09em" },
  },
  components: {
    MuiButton: {
      defaultProps: { disableElevation: true },
      styleOverrides: { root: { minHeight: 44, borderRadius: 10 } },
    },
    MuiIconButton: {
      styleOverrides: { root: { minWidth: 44, minHeight: 44 } },
    },
    MuiPaper: { styleOverrides: { rounded: { borderRadius: 16 } } },
    MuiDialog: {
      styleOverrides: {
        paperFullScreen: {
          margin: 0,
          width: "100%",
          maxHeight: "100%",
          borderRadius: 0,
        },
        paper: {
          margin: 16,
          width: "calc(100% - 32px)",
          maxHeight: "calc(100% - 32px)",
        },
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: { padding: "16px 24px", gap: 8, flexWrap: "wrap" },
      },
    },
    MuiAlert: {
      styleOverrides: {
        root: { alignItems: "center" },
        message: { minWidth: 0, overflowWrap: "anywhere" },
        action: { alignItems: "center", paddingTop: 0 },
      },
    },
    MuiTab: {
      styleOverrides: { root: { minHeight: 52, textTransform: "none" } },
    },
    MuiCard: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: "1px solid #dfe4e2" } },
    },
    MuiAppBar: {
      defaultProps: { color: "inherit" },
      styleOverrides: {
        root: {
          borderBottom: "1px solid #dfe4e2",
          backgroundColor: "#f6f5f1",
          color: "#25353b",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: { fontVariantNumeric: "tabular-nums" },
        ":focus-visible": { outline: "3px solid #397a95", outlineOffset: 3 },
        "@media (prefers-reduced-motion: reduce)": {
          "*, *::before, *::after": {
            animationDuration: "0.01ms !important",
            transitionDuration: "0.01ms !important",
            scrollBehavior: "auto !important",
          },
        },
      },
    },
  },
});
